/* Miraç Palm — horizontal product tabs (Details / Harvest / Uses).
   Regroups Dawn's stacked collapsible_tab accordions into a Graza-style
   horizontal tab row. Without JS the accordions keep working as-is. */
(function () {
  function init() {
    document.querySelectorAll('.product__info-container').forEach(function (container) {
      if (container.querySelector('.product-tabs')) return;
      var accs = container.querySelectorAll('.product__accordion');
      if (accs.length < 2) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'product-tabs';
      var bar = document.createElement('div');
      bar.className = 'product-tabs__bar';
      bar.setAttribute('role', 'tablist');
      var panels = document.createElement('div');
      panels.className = 'product-tabs__panels';
      accs[0].parentNode.insertBefore(wrapper, accs[0]);
      wrapper.appendChild(bar);
      wrapper.appendChild(panels);

      var items = [];
      accs.forEach(function (acc, i) {
        panels.appendChild(acc);
        var titleEl = acc.querySelector('.accordion__title');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-tabs__tab';
        btn.setAttribute('role', 'tab');
        btn.textContent = titleEl ? titleEl.textContent.trim() : 'Tab ' + (i + 1);
        bar.appendChild(btn);
        items.push({ details: acc.querySelector('details'), btn: btn });
        btn.addEventListener('click', function () {
          activate(i);
        });
      });

      function activate(idx) {
        items.forEach(function (item, j) {
          var open = j === idx;
          if (item.details) item.details.open = open;
          item.btn.setAttribute('aria-selected', open ? 'true' : 'false');
        });
      }
      activate(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
